import { Organico } from './../../../services/organico-interrogator.service';
import { PraticaElement } from './../../../components/back-office/ricerca-pratica/ricerca-pratica.component';
import { Component, OnInit, Inject, } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { OrganicoInterrogatorService } from 'src/app/services/organico-interrogator.service';

@Component({
  selector: 'app-search-richiedente-modal',
  templateUrl: './search-richiedente-modal.component.html',
  styleUrls: ['./search-richiedente-modal.component.scss']
})
export class SearchRichiedenteModalComponent implements OnInit {

  public searchRichiedenteFormComponent: FormGroup = this.formBuilder.group({
    cognome: [null, [Validators.maxLength(60)]],
    nome: [null, [Validators.maxLength(60)]],
    codiceFiscale: [null, [Validators.maxLength(16)]],
  });

  public richiedenti: FormControl = new FormControl(null, Validators.required);

  public showTable = false;
  public showNoResults = false;
  public showPartitaIva = false;
  public isRealPerson = true;
  public gender = false;
  public showName = true;
  datasource = [];
  displayedColumns: string[] = ['cognome', 'nome', 'codice fiscale / partita iva', ' '];
  public richLoaded = [];
  /*  {
      key: 'cognomeDenominazione',
      fallBackKey: 'denominazione',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.COGNOME'
    },
    {
      key: 'nome',
      fallBackKey: 'nome',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.NOME'
    },
    {
      key: 'codiceFiscale',
      fallBackKey: 'codiceFiscale',
      value: 'APPLICATION.BACK_OFFICE.BASE_TABLE_UTENTE.CODICE_FISCALE'
    }
  ];*/

  ngOnInit() {}

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SearchRichiedenteModalComponent>,
    private organicoInterrogatorService: OrganicoInterrogatorService,
    @Inject(MAT_DIALOG_DATA) public data: { header: string, isPersonaFisica: boolean, text: string, modalParam: any}) {
  }

  getColumns() {
    return this.displayedColumns;
  }

  loadRichiedenteData(index) {
    this.dialogRef.close(this.richLoaded[index]);
  }

  searchRichiedente() {
    const organicoRichiedente: Organico = this.searchRichiedenteFormComponent.getRawValue();
    this.organicoInterrogatorService.findRichiedenti(organicoRichiedente).toPromise().then( response => {
      this.datasource = response.content.filter((ric => this.data.isPersonaFisica ? ric.personaFisica === true : ric.personaFisica === false)).map((rich) => {
        return {
          cognome: rich.cognomeDenominazione,
          nome: rich.nome,
          'codice fiscale / partita iva': this.data.isPersonaFisica ? rich.codiceFiscale : rich.partitaIva,
          ' ': 'loadData'
        };
      });
      this.showTable = this.datasource.length > 0;
      this.showNoResults = this.datasource.length === 0;
      this.richLoaded = response.content.filter((ric => this.data.isPersonaFisica ? ric.personaFisica === true : ric.personaFisica === false));
    });
  }

}
